(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rxc-integration"] && !Shopify.designMode) return;
  try {
    //Custom Element Register
if (!customElements.get('rxc-activator')) {
  class RXCActivator extends HTMLElement {
    constructor() {
      super();
      this.singletonCheck();
      this.activatorBtn = null;
      this.isLoading = false;
      this.shopUrl = window.location.host + window.Shopify?.routes?.root;
      this.proxyPath = "rxc"
      this.rxcFrameId = "rxc-iframe";
      this.rxcFrameTitle = "RXC Configurator";
      this.rxcErrorMsg = null;
      console.log('[Shopify RXCActivator] Init - Mounting');
      this.activatorBtn = this.querySelector("[name='rxc-activator']");
      this.addToBagBtn = document.querySelector(`#ProductSubmitButton-${this.dataset.sectionId}`);
      this.params = new URLSearchParams(window.location.search);
    }

    connectedCallback() {
      this.activatorBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.showFrame();
      })

      const market = this.activatorBtn.getAttribute('data-market');

      let isMocoAvailable = true;
      let isModelAvailable = true;

      console.log("RXC - MoCo is available");
      this.displayPrescriptionCta(true);
      if(this.dataset.productType == "Optical") {
          this.removeExpressCheckout();
      } 
      this.activatorBtn.style.display = 'flex';
      this.activatorBtn.setAttribute('data-is-available', 'true');

      window.addEventListener('message', this.window_messageHandler);
    } 

    removeExpressCheckout() {
      const expressCheckout = document.querySelector(`.shopify-payment-button`);
      if (expressCheckout) expressCheckout.style.display = "none";
    }

    displayPrescriptionCta(display) {
      document.querySelectorAll(".prescription-cta-link").forEach((cta) => cta.style.display = display ? "" : "none");
    }

    disconnectedCallback() {
      // console.log('[Shopify RXCActivator] Unmounting');
      window.removeEventListener('message', this.window_messageHandler);
      this.activatorBtn?.removeEventListener('click', this.activator_clickHandler);
    }

    singletonCheck() {
      if (document.getElementsByTagName('rxc-activator').length > 1) {
        console.error('Multiple instances of <rxc-activator> detected. Only one instance is allowed.');
        return false;
      }
      return true;
    }
  
    setLoading(isLoading) {
      if (this.activatorBtn) {
        this.activatorBtn.toggleAttribute('data-loading', isLoading);
        this.activatorBtn.ariaDisabled = isLoading;
      }
  
      this.isLoading = isLoading;
    }
  
    activator_clickHandler = evt => {
      evt.preventDefault();
  
      if (!this.shopUrl) {
        console.error('Shop URL not found');
        return;
      }
  
      if (!this.isLoading) {
        this.setLoading(true);
        this.showFrame();
      }
    }

    redirectToCart() {
      const cartUrl = window.routes.cart_url || `${window.Shopify?.routes?.root || "/"}cart`;
      const separator = cartUrl.includes('?') ? '&' : '?';
      window.location.href = `${cartUrl}?disable_event=true`;
    }
  
    showFrame() {
      const urlParams = new URLSearchParams(window.location.search);
  
      const variantId = urlParams.get('variant') || this.activatorBtn.getAttribute('data-variant-id');
      const country = this.activatorBtn.getAttribute('data-market');
      const market = this.activatorBtn.getAttribute('data-market-id');
      const language = this.activatorBtn.getAttribute('data-language');
      const currency = this.activatorBtn.getAttribute('data-currency');
  
      const iframeUrl = new URL(`${window.location.protocol}//${this.shopUrl}apps/${this.proxyPath}/prescription/index`);
      const iframe = document.getElementById(this.rxcFrameId) || document.createElement('iframe');
  
      iframeUrl.searchParams.set('variantId', variantId);
      iframeUrl.searchParams.set('market', country);
      iframeUrl.searchParams.set('market_id', market);
      iframeUrl.searchParams.set('language', language);
      iframeUrl.searchParams.set('currency', currency);
  
      iframe.id = this.rxcFrameId;
      iframe.title = this.rxcFrameTitle;
      iframe.tabIndex = -1;
      iframe.src = iframeUrl.toString();
  
      iframe.onerror = () => {
        console.error('RXC App Embed Error');
        this.onRXCError();
      };
  
      iframe.toggleAttribute('data-loading', true);
      document.body.appendChild(iframe);
    }
  
    onFrameLoaded() {
      const rxcAppEmbed = document.getElementById(this.rxcFrameId);
      this.setLoading(false);
  
      if (!rxcAppEmbed) {
        console.error('RXC App Embed not found');
        return;
      }
  
      rxcAppEmbed.toggleAttribute('data-loading', false);
      rxcAppEmbed.toggleAttribute('data-ready', true);
    }
  
    onRXCError() {
      let messageTemplate = this.querySelector('p[data-rxc-error]') || document.createElement('p');
      messageTemplate.setAttribute('data-rxc-error', true);
      messageTemplate.textContent = this.rxcErrorMsg;
      this.activatorBtn.insertAdjacentElement('afterend', messageTemplate);
      this.setLoading(false);
    }
  
    window_messageHandler = event => {
      const rxcAppData = event?.data?.rxcApp;
  
      if (!rxcAppData) return;
  
      switch (rxcAppData.type) {
        case 'RXC_IS_ON_ERROR':
          console.log('RXC_IS_ON_ERROR RECEIVED:', event.data);
          this.onRXCError();
          break;
        case 'RXC_LOADED':
          console.log('[Shopify RXCActivator] Message from RXC APP:', event.data);
          this.onFrameLoaded();
          break;
      }
    };
  }

  customElements.define('rxc-activator', RXCActivator);
}
  } catch(e) { console.error(e); }
})();

})();
